import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { baseUrl, getHeaders } from '../../app/structure/dashboards/webx-chat/urls';
import { environment } from './../../environments/environment';
import { getPlainGemIdentityHeaders } from '../helpers/gem-headers.helpers';
import 'rxjs/add/operator/map';
@Injectable()
export class WebexService {
 

  constructor(private httpWithoutToken: HttpClient, private http: HttpClient) { }

  private parseStoredJson(key: string): any {
    try {
      const raw = localStorage.getItem(key);
      if (!raw) {
        return null;
      }
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }

  private getGemSessionHeaders(
    complianceEngine: string,
    complianceEngineUrl: string,
    governanceUrl: string
  ): { headers: Record<string, string>; user: any } | null {
    const user = this.parseStoredJson('user');
    // GEM CryptLib cannot decrypt CryptoJS — send identity headers as plaintext
    const identity = getPlainGemIdentityHeaders();
    if (!user?._id || !identity) {
      console.warn('WebexService: missing user or company session in localStorage');
      return null;
    }

    return {
      user,
      headers: {
        'Content-Type': 'application/json',
        accept: '*/*',
        'authentication-token': localStorage.getItem('token') || '',
        companyId: identity.companyId,
        companyName: identity.companyName,
        complianceEngine,
        complianceEngineUrl,
        governanceUrl,
        uniqueUserId: identity.uniqueUserId,
        userId: identity.userId,
      },
    };
  }

  private missingSessionError(): Promise<any> {
    return Promise.reject('User session not available');
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }


  endMeetingByModerator(complianceEngine, complianceEngineUrl, governanceUrl, gemAccessUrl, meetingId, status): Promise<any> {
    const session = this.getGemSessionHeaders(complianceEngine, complianceEngineUrl, governanceUrl);
    if (!session) {
      return this.missingSessionError();
    }

    const url = gemAccessUrl + "meetingAttendance/startStopMeeting/" + meetingId + "/startStopBooleanStatus/" + status;

    return this.httpWithoutToken.post(url, {}, { headers: session.headers }).toPromise()
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  leaveMeetingByParticipants(complianceEngine, complianceEngineUrl, governanceUrl, gemAccessUrl, meetingId, leaveDateTimefromDevice): Promise<any> {
    const session = this.getGemSessionHeaders(complianceEngine, complianceEngineUrl, governanceUrl);
    if (!session) {
      return this.missingSessionError();
    }

    const url = gemAccessUrl + "meetingAttendance/leaveMeeting/" + meetingId + "/leaveDateTimefromDevice/" + leaveDateTimefromDevice;

    return this.httpWithoutToken.put(url, {}, { headers: session.headers }).toPromise()
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  joinMeetingAndParticipantAttendance(complianceEngine, complianceEngineUrl, governanceUrl, gemAccessUrl, meetingId, attendanceType): Promise<any> {
    const session = this.getGemSessionHeaders(complianceEngine, complianceEngineUrl, governanceUrl);
    if (!session) {
      return this.missingSessionError();
    }

    const user = session.user;
    const url = gemAccessUrl + `meetingAttendance/save/${meetingId}/attendanceMode/${attendanceType}`;

    var attendanceObject = {
      attendanceObject: {
        "meetingId": meetingId,
        "meetingAttendanceMode": attendanceType,
        "memberName": user.FirstName,
        "memberType": user.TypeOfUser,
        "userGovevaId": user._id,
        "uniqueUserId": user.UniqueUserId
      }
    }

    return this.httpWithoutToken.post(url, JSON.stringify(attendanceObject), { headers: session.headers }).toPromise()
      .then(response => {
        var isMeetingInitiated = localStorage.getItem('isMeetingInitiated');
        console.log("isMeetingInitiated------>>>", isMeetingInitiated);
        if (isMeetingInitiated == "join" && localStorage.getItem('WebexAcessToken')) {
          this.setWebExAccessToken();
        }
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }


  setWebExAccessToken() {
    let headers = {};

    const getHeraders = (key, data) => {
      headers[key] = data;
    }
    getHeraders('Content-Type', 'application/json');
    getHeraders('accept', '*/*');
    var token = localStorage.getItem('token');
    getHeraders('x-access-token', token);
    var token = localStorage.getItem('token')
    var webExAccessToken = localStorage.getItem('WebexAcessToken');
    var webExAccessTokenExpiry = localStorage.getItem('WebexAcessTokenExpiry');
    var webExRefreshToken = localStorage.getItem('WebexRefreshToken');
    var webExRefreshTokenExpiry = localStorage.getItem('WebexRefreshTokenExpiry');

    var body = {
      webExAccessToken: webExAccessToken,
      webExAccessTokenExpiry: webExAccessTokenExpiry,
      webExRefreshToken: webExRefreshToken,
      webExRefreshTokenExpiry: webExRefreshTokenExpiry
    }
    console.log("setWebExAccessToken body------>>>", body);
    return this.httpWithoutToken.post(environment.nonValidateUrl + 'user/setWebExAccessToken', body, { headers: headers }).toPromise()
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  TranscriptGenerate(meetingId){
    const url = `${environment.transcriptURL}/generate-files`;
    var token = localStorage.getItem('token')
    var webExAccessToken = localStorage.getItem('WebexAcessToken');    
    let headers = {
      'Content-Type': 'application/json',
      'x-access-token': token
    };
    

    var body = {
      webex_token: webExAccessToken,
      meeting_id : meetingId
    }
    return this.httpWithoutToken.post(url,body, { headers: headers }).toPromise()
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  getTranscriptURL(meetingId) {
    const token = localStorage.getItem('token');
    const url = `${environment.transcriptURL}/download-transcript`;
    var webExAccessToken = localStorage.getItem('WebexAcessToken');    
    var body = {
      webex_token: webExAccessToken,
      meeting_id : meetingId
    }
    let headers = {
      'Content-Type': 'application/json',
      'x-access-token': token
    };
    return this.httpWithoutToken.post(url,body, {
      headers: headers, 
      responseType: 'blob', // Expect a blob response
      observe: 'response'   // Observe the full HTTP response, including headers
    })
    .toPromise()
    .then(response => {
      // Access headers from HttpResponse
      const contentType = response.headers.get('Content-Type');
  
      if (contentType?.includes('application/json')) {
        // If JSON, parse it
        return response.body?.text().then(text => {
          try {
            const json = JSON.parse(text);
            return Promise.resolve(json); // Return parsed JSON
          } catch (error) {
            return Promise.reject('Failed to parse JSON response');
          }
        });
      } else {
        // Otherwise, treat as Blob
        return Promise.resolve(response.body); // Return Blob directly
      }
    })
    .catch(this.handleError);
  }

  getMOMURL(meetingId) {
    var webExAccessToken = localStorage.getItem('WebexAcessToken');    
    const token = localStorage.getItem('token');
    const url = `${environment.transcriptURL}/download-mom`;
    let headers = {
      'Content-Type': 'application/json',
      'x-access-token': token
    };
    var body = {
      webex_token: webExAccessToken,
      meeting_id : meetingId
    }
    return this.httpWithoutToken.post(url,body, { 
      headers: headers, 
      responseType: 'blob', // Expect a blob response
      observe: 'response'   // Observe the full HTTP response, including headers
    })
    .toPromise()
    .then(response => {
      // Access headers from HttpResponse
      const contentType = response.headers.get('Content-Type');
  
      if (contentType?.includes('application/json')) {
        // If JSON, parse it
        return response.body?.text().then(text => {
          try {
            const json = JSON.parse(text);
            return Promise.resolve(json); // Return parsed JSON
          } catch (error) {
            return Promise.reject('Failed to parse JSON response');
          }
        });
      } else {
        // Otherwise, treat as Blob
        return Promise.resolve(response.body); // Return Blob directly
      }
    })
    .catch(this.handleError);
  }
  


  autoLeftParticipant(complianceEngine, complianceEngineUrl, governanceUrl, gemAccessUrl, meetingId): Promise<any> {
    const session = this.getGemSessionHeaders(complianceEngine, complianceEngineUrl, governanceUrl);
    if (!session) {
      return this.missingSessionError();
    }

    const url = gemAccessUrl + "meetingAttendance/hasMeetingStarted/" + meetingId;

    return this.httpWithoutToken.get(url, { headers: session.headers }).toPromise()
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  getSIPurl(meetingId) {
    var token = localStorage.getItem('token');
    const url = environment.clientUrl + "meetingForVc/" + meetingId;

    let headers = {};

    const getHeraders = (key, data) => {
      headers[key] = data;
    }
    getHeraders('Content-Type', 'application/json');
    getHeraders('x-access-token', token);
 
   
    
    return this.httpWithoutToken.get(url, { headers: headers }).toPromise()
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }
 


  listMeetings(meetingNumber) {
    return new Promise((resolve, reject) => {
      fetch(baseUrl + "/v1/meetings?meetingNumber=" + meetingNumber, {
        method: "GET",
        headers: getHeaders()
      })
        .then(res => res.json())
        .then(resJson => resolve(resJson))
        .catch(err => reject(err))
    })
  }


  getGuestToken(username) {
    const url = environment.nonValidateUrl + "auth/getJWTTForWebexGuest/" + username;

    return this.httpWithoutToken.get(url).toPromise()
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  testInternetSpeed() {

    const url = environment.nonValidateUrl + "webex/testInternetSpeed";

    return this.httpWithoutToken.get(url).toPromise()
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }

  getCiscoIP(complianceEngine, complianceEngineUrl, governanceUrl, gemAccessUrl): Promise<any> {
    const session = this.getGemSessionHeaders(complianceEngine, complianceEngineUrl, governanceUrl);
    if (!session) {
      return this.missingSessionError();
    }

    const url = gemAccessUrl + "configuration/getAll";

    return this.httpWithoutToken.get(url, { headers: session.headers }).toPromise()
      .then(response => {
        return Promise.resolve(response);
      })
      .catch(this.handleError);
  }
  recording(meetingId: any,recordingStarted: boolean, recordingPaused: boolean, locked: boolean): Observable<any> {
    const session = this.getGemSessionHeaders('PSS', environment.pssServerUrl, environment.nonValidateUrl);
    if (!session) {
      return Observable.throw('User session not available');
    }

    let headers = new HttpHeaders()
    headers.append('Content-Type', 'application/json');
    headers.append('accept', '*/*');
    headers.append('authentication-token', session.headers['authentication-token']);
    headers.append('companyId', session.headers.companyId);
    headers.append('companyName', session.headers.companyName);
    headers.append('uniqueUserId', session.headers.uniqueUserId);
    headers.append('userId', session.headers.userId);
  
    return this.http.put(`https://webexapis.com/v1/meetings/controls?meetingId=${meetingId}`, {
      recordingStarted: +recordingStarted,
      recordingPaused: +recordingPaused,
      locked: +locked
    },{ 'headers': headers } );
  }
//   muteAll(meetingId: any,object) {
//     var headers = new Headers();
//     headers.append('Content-Type', 'application/json');
//     var token = localStorage.getItem('token')
//     headers.append("x-access-token", token)
//     console.log('JSON.stringify(formData)', object);
//     return this.http.put('https://webexapis.com/v1/meetingParticipants/' + meetingId, object, { headers: headers })
//         .map(res => res.json())
// }
muteAllParticipant(userId: any,object): Promise<any> {
  const session = this.getGemSessionHeaders('PSS', environment.pssServerUrl, environment.nonValidateUrl);
  if (!session) {
    return Promise.reject('User session not available');
  }

  const url =  "https://webexapis.com/v1/meetingParticipants/" + userId;
  let headers = {};

  const getHeraders = (key, data) => {
    headers[key] = data;
  }
  getHeraders('Content-Type', 'application/json');
  getHeraders('accept', '*/*');
  getHeraders('authentication-token', session.headers['authentication-token']);
  getHeraders('companyId', session.headers.companyId);
  getHeraders('companyName', session.headers.companyName);
  getHeraders('uniqueUserId', session.headers.uniqueUserId);
  getHeraders('userId', session.headers.userId);

  return this.httpWithoutToken.put(url, object, { headers: headers }).toPromise()
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(this.handleError);
}

muteall(userId:any,object): Promise<any> {
  const url =  "https://webexapis.com/v1/meetingParticipants/" + userId;
  return this.http.put(url, object).toPromise()
    .then(response => {
      return Promise.resolve(response);
    })
    .catch(this.handleError)
}

}
